module.exports = __webpack_public_path__ + "static/media/win-game.8e32e8d3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/win-game.mp3
// module id = 207
// module chunks = 0